import { Box, Stack, styled } from '@mui/system';
import themes from '~/themes';

export const StyledContainer = styled(Stack)(() => ({
  flexDirection: 'column',
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '16px',
}));

export const StyledTitle = styled(Box)(() => ({
  display: 'flex',
  fontSize: 16,
  fontWeight: '500',
  color: themes.color.violet500,
}));

export const StyledContent = styled(Box)(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  flex: 1,
}));
